import { AuthLayout } from "@/components/catalyst/AuthLayout";
import { Heading, Subheading } from "@/components/catalyst/Heading";
import { Logo } from "@/components/Logo";
import { TurnstileProvider } from "@/hooks/use-turnstile";
import { Form } from "./Form";

export function PartnerPortal() {
	return (
		<AuthLayout>
			<TurnstileProvider>
				<div className="flex flex-col gap-6 w-full max-w-sm">
					<div className="flex flex-col items-center gap-4">
						<Logo />
						<Heading>Access your payout dashboard</Heading>
						<Subheading className="text-center">
							We’ll email you a secure link to view earnings and manage payout
							details.
						</Subheading>
					</div>
					<Form />
				</div>
			</TurnstileProvider>
		</AuthLayout>
	);
}
